import React, { useRef } from 'react';

import useToast, { UseToastProps } from './useToast';

import { useInView } from 'framer-motion';

type Props = Omit<UseToastProps, 'showToast' | 'toast'> & {
  onClick?: () => void;
  toastClassName?: string;
};

export type UseScrollDownToast<T> = {
  ref: React.MutableRefObject<T | null>;
};

export const useScrollDownToast = <T extends Element>({
  onClick,
  toastClassName,
  ...props
}: Props): UseScrollDownToast<T> => {
  const ref = useRef<T | null>(null);
  const inViewport = useInView(ref);

  useToast({
    showToast: inViewport,
    toast: (
      <div onClick={onClick} className={toastClassName}>
        Scroll down
      </div>
    ),
    ...props,
  });

  return { ref };
};
